<template>
  <div>
    <ul class="policy_list">
      <li class="item" v-for="(v, k) in dataList" :key="k">
        <div
          v-if="
            v.insuranceStatus === 'examine_pass' &&
              (v.payStatus === 'payYet' || v.payStatus === 'partRefund')
          "
          class="item-status"
        >
          待生效
        </div>
        <div v-else class="item-status">
          {{ v.insuranceStatus | policyStatus }}
        </div>
        <div class="item-name">{{ v.insuranceName }}</div>
        <div class="itemList" v-for="(child, cindex) in list" :key="cindex">
          <div class="item_left">{{ child.title }}</div>
          <div v-if="child.value == 'payStatus'" class="item.right">
            {{ v[child.value] | payStatus }}
          </div>
          <div v-else class="item.right">{{ v[child.value] }}</div>
        </div>
        <div class="btn_group">
          <div class="tr-flex" @click="goDetail(v)">
            查看详情
          </div>
          <div v-show="showQuick(v)" class="tr-flex" @click="quickInsure(v)">
            延续保障
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { PolicyPayStatus, PolicyStatus } from '@/util/enum-data'

  export default {
    name: 'PolicyList',
    components: {},
    mixins: [],
    props: {
      dataList: {
        type: Array,
        default: function() {
          return []
        }
      }
    },
    data() {
      return {
        list: [
          { title: '参保人：', value: 'insuredPersonName' },
          { title: '支付状态：', value: 'payStatus' },
          { title: '保费：', value: 'insuredFeeAmount' }
        ]
      }
    },
    filters: {
      payStatus: function(val) {
        return PolicyPayStatus[val] || ''
      },
      policyStatus(val) {
        return PolicyStatus[val] || ''
      },
      shortDate: function(val) {
        return val ? val.substr(0, 10) : ''
      },
      insuredFilter(val) {
        const arr = val.userInsureEntities.reduce((a, b) => {
          const name = b.personnelType === 'insured' ? [b.userName] : []

          return [].concat(a, name)
        }, [])
        return arr.join(', ')
      }
    },
    methods: {
      async quickInsure(v) {
        this.$router.push({
          path: '/area-insu-buy-detail',
          query: {
            insuranceId: v.insuranceId,
            fromSourceCode: v.fromSourceCode,
            baosicode: 'HN22001',
            isRenewal: '20'
          }
        })
      },
      goDetail(v) {
        this.$router.push({ path: `/policy-detail/${v.insuranceId}` })
      },
      showQuick(v) {
        let list = ['effective', 'unEffective', 'generating']
        let flag =
          v.insuranceProductCode !== 'HN22001' &&
          list.includes(v.insuranceStatus)
        return flag
      }
    }
  }
</script>

<style scoped lang="scss">
  .policy_list {
    .item {
      position: relative;
      width: 100%;
      padding: px2rem(10, 375) px2rem(10, 375);
      margin-bottom: px2rem(10, 375);
      border-radius: px2rem(10, 375);
      color: #4c4c4c;
      background-color: #fff;
      box-shadow: 0px 4px 16px 0px #eff5ff;
      .item-status {
        position: absolute;
        top: px2rem(10, 375);
        right: 0;
        padding: 0 px2rem(10, 375);
        border-top-left-radius: px2rem(20, 375);
        border-bottom-left-radius: px2rem(20, 375);
        font-size: px2rem(15, 375);
        line-height: 1.5;
        text-align: center;
        color: #fff;
        background-color: $themeColor;
      }

      .item-name {
        width: 75%;
        margin-bottom: px2rem(10, 375);
        font-size: px2rem(16, 375);
        line-height: 1.5;
      }
      .itemList {
        display: flex;
        margin: xvw(20) 0;
        .item_left {
          width: xvw(200);
        }
      }
      .btn_group {
        display: flex;
        align-items: center;
      }
      .tr-flex {
        width: 90%;
        margin: 0 xvw(20);
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background: linear-gradient(to right, #db0003, #ff6c61);
        background-size: contain;
        background-position-x: center;
        border-radius: px2rem(18, 375);
        height: px2rem(36, 375);
      }
    }
  }
</style>
